var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCashReceipts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.5C8.38105 2.5 3 7.88105 3 14.5C3 21.1189 8.38105 26.5 15 26.5C21.6189 26.5 27 21.1189 27 14.5C27 7.88105 21.6189 2.5 15 2.5ZM19.3705 10.3316H16.8442C17.1726 10.7862 17.4 11.3168 17.5263 11.8726H19.3705V13.6916L17.5263 13.6914C17.1221 15.6114 15.4043 17.0514 13.358 17.0514H12.9285L17.7285 21.9272L15.0507 21.9274L10.6296 17.4557V15.1315H13.3581C14.3433 15.1315 15.177 14.5252 15.5307 13.6914H10.6296V11.8725H15.5307C15.177 11.0136 14.3433 10.4324 13.3581 10.4324L10.6296 10.4326V8.51263H19.3454V10.3316L19.3705 10.3316Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashReceipts);
export default __webpack_public_path__ + "static/media/CashReceipts.46797bd5523aea1b2338a0ee81b6a64f.svg";
export { ForwardRef as ReactComponent };